/**
 * MobileBottomNav
 * 
 * A mobile-optimized bottom navigation bar that provides
 * easy thumb access to main navigation items.
 */

import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { Icon } from '../../common/Icons';
import type { SemanticIconType } from '../../common/Icons/SemanticIcons';

interface NavItem {
  to: string;
  icon: SemanticIconType;
  label: string;
}

const navItems: NavItem[] = [
  { to: '/', icon: 'Workspace', label: 'Workspace' },
  { to: '/knowledge', icon: 'Knowledge', label: 'Knowledge' },
  { to: '/profile', icon: 'Profile', label: 'Profile' },
];

export const MobileBottomNav: React.FC = () => {
  const location = useLocation();

  return (
    <nav className="lg:hidden fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-neutral-200 safe-area-pb">
      <div className="flex items-stretch h-16">
        {navItems.map((item) => {
          const isActive = item.to === '/' 
            ? location.pathname === '/' 
            : location.pathname.startsWith(item.to);
          
          return (
            <NavLink
              key={item.to}
              to={item.to}
              className={`flex-1 flex flex-col items-center justify-center gap-1 transition-colors ${
                isActive
                  ? 'text-blue-600'
                  : 'text-neutral-400 active:text-neutral-600'
              }`}
            >
              <Icon 
                name={item.icon} 
                className={`w-6 h-6 transition-transform ${isActive ? 'scale-110' : ''}`} 
              />
              <span className={`text-[10px] font-medium ${isActive ? 'text-blue-600' : 'text-neutral-500'}`}>
                {item.label}
              </span>
            </NavLink>
          );
        })}
      </div>
    </nav>
  );
};

export default MobileBottomNav;

